var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIosPlatformIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8288 16.3632C37.5504 16.5792 32.6352 19.3488 32.6352 25.5072C32.6352 32.6304 38.8896 35.1504 39.0768 35.2128C39.048 35.3664 38.0832 38.664 35.7792 42.024C33.7248 44.9808 31.5792 47.9328 28.3152 47.9328C25.0512 47.9328 24.2112 46.0368 20.4432 46.0368C16.7712 46.0368 15.4656 47.9952 12.48 47.9952C9.4944 47.9952 7.4112 45.2592 5.016 41.8992C2.2416 37.9536 0 31.824 0 26.0064C0 16.6752 6.0672 11.7264 12.0384 11.7264C15.2112 11.7264 17.856 13.8096 19.848 13.8096C21.744 13.8096 24.7008 11.6016 28.3104 11.6016C29.6784 11.6016 34.5936 11.7264 37.8288 16.3632ZM26.5968 7.6512C28.0896 5.88 29.1456 3.4224 29.1456 0.9648C29.1456 0.624 29.1168 0.2784 29.0544 0C26.6256 0.0912 23.736 1.6176 21.9936 3.6384C20.6256 5.1936 19.3488 7.6512 19.3488 10.1424C19.3488 10.5168 19.4112 10.8912 19.44 11.0112C19.5936 11.04 19.8432 11.0736 20.0928 11.0736C22.272 11.0736 25.0128 9.6144 26.5968 7.6512Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIosPlatformIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ios_platform_icon.a98f335f0e8069b18032a08a157100e6.svg";